import {BiologicsFeature, Capability} from 'auth/capabilities/CapabilityFeatureConstants';
import isCapabilityEnabledForTenant from 'auth/capabilities/isCapabilityEnabledForTenant';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';

export function isBiologicsEnabled(): boolean {
  return isCapabilityEnabledForTenant(Capability.BIOLOGICS);
}

export function canUseBiologicsFeature(requiredBiologicsFeature: BiologicsFeature): boolean {
  return isBiologicsEnabled() && isFeatureEnabled({feature: requiredBiologicsFeature});
}
